<script setup lang="ts">
import ConnxIcon from '@/components/Atoms/ConnxIcon.vue';
</script>

<template>
  <div class="tw-text-center">
    <connx-icon
      name="far fa-shield-check"
      class="tw-w-20 tw-mx-auto tw-text-connx-success tw-mb-10 tw-h-auto"
    />
    <h2 class="tw-text-3xl tw-mb-4">
      Well Done!
    </h2>
    <h2 class="tw-text-3xl tw-mb-8">
      You are now more secure than ever!
    </h2>
    <p>
      Next time you log in, you will be asked for the 6-digit code from your authenticator app.
    </p>
  </div>
</template>
